import { type NavigationProps } from '@react-native-common/common'

type NavigationData = NavigationProps['data']

export const BASE_B2B_NAVIGATION_MODEL: NavigationData = {
  logo: {
    href: '/',
  },
  profile: {
    avatarUrl: '',
    username: '',
    email: '',
    actingAsLabel: 'Navigation.MyProfile.ActingAs',
    agentWarningMessage: '',
  },
  items: [
    {
      type: 'Projects',
      label: 'Navigation.Projects',
      href: '/projects/',
      display: ['desktop', 'mobile'],
    },
    {
      type: 'Listings',
      label: 'Navigation.Listings',
      href: '/listings/',
      display: ['desktop', 'mobile'],
    },
    {
      type: 'Hub',
      label: 'Navigation.Hub',
      href: '/hub/',
      display: ['desktop', 'mobile'],
    },
    {
      type: 'Messages',
      label: 'Navigation.Messages',
      href: '/messages/',
      display: ['desktop', 'mobile'],
      mobile: {
        order: 4,
      },
    },
    {
      type: 'Contacts',
      label: 'Navigation.Contacts',
      href: '/contacts/',
      display: ['desktop', 'mobile'],
      mobile: {
        order: 5,
      },
    },
    {
      type: 'Reports',
      label: 'Navigation.Reports',
      href: '/reports/',
      display: ['desktop', 'mobile'],
      mobile: {
        order: 6,
      },
    },
    {
      type: 'Accounts',
      label: 'Navigation.Accounts',
      href: '/accounts/',
      display: ['desktop', 'mobile'],
      mobile: {
        order: 3,
      },
    },
    {
      type: 'Agents',
      label: 'Navigation.Agents',
      display: ['desktop'],
      mobileMoreSection: {
        enabled: true,
        order: 1,
      },
      submenu: [
        {
          type: 'ByLocation',
          label: 'Navigation.Agents.ByLocation',
          href: '/agents/location',
        },
        {
          type: 'Matching',
          label: 'Navigation.Agents.Matching',
          href: '/agents',
        },
      ],
    },
    {
      type: 'Products',
      label: 'Navigation.Products',
      display: ['desktop'],
      mobileMoreSection: {
        enabled: true,
        order: 2,
      },
      submenu: [
        {
          type: 'Global',
          label: 'Navigation.Products.Global',
          href: '/global',
          description: 'Navigation.Products.Global.Description',
        },
        {
          type: 'ListingPromotions',
          label: 'Navigation.Products.ListingPromotions',
          href: '/promotions',
          description: 'Navigation.Products.ListingPromotions.Description',
        },
        {
          type: 'Luxury',
          label: 'Navigation.Products.Luxury',
          href: '/luxury',
          description: 'Navigation.Products.Luxury.Description',
        },
        {
          type: 'Elite',
          label: 'Navigation.Products.Elite',
          href: '/elite',
          description: 'Navigation.Products.Elite.Description',
        },
      ],
    },
    {
      type: 'Resources',
      label: 'Navigation.Resources',
      display: ['desktop'],
      mobileMoreSection: {
        enabled: true,
        order: 3,
      },
      submenu: [
        {
          type: 'InternationalNetwork',
          label: 'Navigation.Resources.InternationalNetwork',
          href: '/resources/network',
        },
        {
          type: 'MarketingKit',
          label: 'Navigation.Resources.MarketingKit',
          href: '/resources/marketing-kit',
        },
        {
          type: 'Blog',
          label: 'Navigation.Resources.Blog',
          href: 'https://agent.properstar.com/',
        },
      ],
    },
    {
      type: 'Help',
      label: 'Navigation.Help',
      display: ['desktop'],
      mobileMoreSection: {
        enabled: true,
        order: 4,
      },
      side: 'right',
      submenu: [
        {
          type: 'KnowledgeBase',
          label: 'Navigation.Help.KnowledgeBase',
          href: 'https://help.properstar.com/knowledge',
        },
        {
          type: 'Contact',
          label: 'Navigation.Help.Contact',
          href: '/contact',
        },
        {
          type: 'TermsOfUse',
          label: 'Navigation.Help.TermsOfUse',
          href: '/terms-of-use',
        },
      ],
    },
    {
      type: 'More',
      label: 'Navigation.More',
      display: ['mobile'],
      mobile: {
        order: 5,
      },
    },
    {
      type: 'MyProfile',
      label: 'Navigation.MyProfile',
      display: ['desktop', 'mobile'],
      side: 'right',
      href: '/my-profile/',
      desktop: {
        label: 'Navigation.MyProfile.DesktopLabel',
      },
      mobile: {
        order: 6,
      },
      submenu: [
        {
          type: 'ActAs',
          label: 'Navigation.MyProfile.ActAs',
          href: '/accounts/my-account/users/act-as',
          icon: 'actas',
          group: 'primary',
        },
        {
          type: 'MyProfile',
          label: 'Navigation.MyProfile.MyProfile',
          href: '/my-profile/',
          icon: 'profileRound',
          group: 'primary',
        },
        {
          type: 'MyAccount',
          label: 'Navigation.MyProfile.MyAccount',
          href: '/accounts/my-account',
          icon: 'profileDropdown',
          group: 'primary',
        },
        {
          type: 'Accounts',
          label: 'Navigation.Accounts',
          href: '/accounts/',
          icon: 'team',
          group: 'primary',
        },
        {
          type: 'RegionalSettings',
          label: 'Navigation.MyProfile.RegionalSettings',
          href: '/my-profile/settings',
          icon: 'planet',
          group: 'primary',
        },
        {
          type: 'Notifications',
          label: 'Navigation.MyProfile.Notifications',
          href: '/my-profile/notifications',
          icon: 'notification',
          group: 'primary',
        },
        {
          type: 'Security',
          label: 'Navigation.MyProfile.Security',
          href: '/my-profile/security',
          icon: 'lock',
          group: 'primary',
        },
        {
          type: 'Billing',
          label: 'Navigation.MyProfile.Billing',
          href: '/accounts/my-account/billing',
          icon: 'billing',
          group: 'primary',
        },
        {
          type: 'GetMobileApp',
          label: 'Navigation.MyProfile.GetMobileApp',
          icon: 'smartphone',
          group: 'secondary',
        },
        {
          type: 'SwitchToHome',
          label: 'Navigation.MyProfile.SwitchToHome',
          icon: 'refresh',
          group: 'secondary',
        },
        {
          type: 'Logout',
          label: 'Navigation.MyProfile.Logout',
          icon: 'disconnect',
          group: 'logout',
        },
      ],
    },
  ],
}
